import React from 'react';
import { Bold } from 'styled-icons/boxicons-regular/Bold';

function BoldIcon(props) {
  return (
    <Bold {...props} className={'icon'} />
  );
}

export default BoldIcon;
